import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import sidebarHelper from "../../../helpers/sidebar";

export default function ReportMenu({ activeItem }) {
  return (
    <li className="nav-item">
      <Link
        to="/report"
        className={`nav-link  d-flex
        ${sidebarHelper.checkActiveItem(activeItem, "report")} `}
      >
        <i class="fa-solid fa-chart-line pl-2"></i>
        <p>گزارش سایت ها</p>
      </Link>
    </li>
  );
}
